export const COOKIES = {
    lang: "lang",
    lastSelectedRestaurantId: "lri"
};
